export default "__VITE_ASSET__DIkOSWIx__"